export interface IIconTextCodes {
  folderIcon: string;
  tariffIcon: string;
  subscriptionIcon: string;
  zoneIcon: string;
  deviceIcon: string;
}

// how to: search for the icon in _icons_ibm.scss and transform the hex value under 'content' to a decimal value => '&#<icon's decimal value>'
export const iconTextCodes = {
  folderIcon: '&#60428;',        // .icon-folder
  tariffIcon: '&#60131;',        // .icon-currency
  subscriptionIcon: '&#61412;',  // .icon-ticket
  zoneIcon: '&#60684;',          // .icon-location
  deviceIcon: '&#59991;',        // .icon-chip
  qrCodeIcon: '&#61031;'         // .icon-qr-code
};
